import type { ReactNode } from "react";

import { cn } from "@/shared/lib/utils";

export interface MethodIllustrationStageProps {
  children: ReactNode;
  className?: string;
}

/**
 * The quiet panel a step-up method's illustration sits on: a fixed height so the card never jumps while the
 * drawing loops, and a muted ground so the drawing's card-coloured shapes (the phone, the code bubble, the
 * PIN slots) read against it in both themes.
 */
export function MethodIllustrationStage({ children, className }: MethodIllustrationStageProps) {
  return (
    <div
      className={cn(
        "flex h-[92px] w-full items-center justify-center overflow-hidden rounded-md bg-muted/50 ring-1 ring-border/60 ring-inset",
        className,
      )}
    >
      {children}
    </div>
  );
}
